import { render, staticRenderFns } from "./ModalEditOptionText.vue?vue&type=template&id=c08443da"
import script from "./ModalEditOptionText.vue?vue&type=script&lang=js"
export * from "./ModalEditOptionText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports